import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

/**
 * AIThinking. friendly loading state for AI requests. Replaces the bland
 * "Thinking…" italic everywhere we hit Compass / the Brain. Rotates a few
 * pieces of context-aware microcopy so users don't feel they're staring at
 * a frozen spinner during a 3-5 second Claude call.
 *
 * The dots animate with a wave (each delayed ~150ms). gives the impression
 * of typing.
 */
const DEFAULT_PHRASES = [
 "Reading the Act",
 "Cross-referencing your documents",
 "Drafting a response",
 "Citing the relevant sections",
 "Almost there",
];

export default function AIThinking({ phrases = DEFAULT_PHRASES, compact = false, testid = "ai-thinking" }) {
 const [i, setI] = useState(0);
 useEffect(() => {
 const id = setInterval(() => setI((x) => (x + 1) % phrases.length), 2200);
 return () => clearInterval(id);
 }, [phrases.length]);

 return (
 <div
 className={`${compact ? "" : "card"} flex items-center gap-2.5 text-sm text-[#5a6b7a]`}
 data-testid={testid}
 role="status"
 aria-live="polite"
 >
 <Sparkles size={14} strokeWidth={1.5} className="text-[#1B6C62] shrink-0" />
 <span className="font-serif italic">{phrases[i]}</span>
 <span className="inline-flex gap-0.5">
 <span className="w-1 h-1 rounded-full bg-[#1B6C62] animate-bounce" style={{ animationDelay: "0ms" }} />
 <span className="w-1 h-1 rounded-full bg-[#1B6C62] animate-bounce" style={{ animationDelay: "150ms" }} />
 <span className="w-1 h-1 rounded-full bg-[#1B6C62] animate-bounce" style={{ animationDelay: "300ms" }} />
 </span>
 </div>
 );
}
